import React from 'react'
import { InnerPageLayout } from 'routes/layouts'
import { PricingPlans, PricingStartup, PricingFAQ } from './index'

export const Pricing = () => {
  return (
    <InnerPageLayout>
      <div className='pricing'>
        <div className='container'>
          <div className='pricing__body'>
            <h1 className='pricing__title'>Pricing</h1>

            <PricingPlans />
            <PricingStartup />
            <PricingFAQ />
          </div>
        </div>
      </div>
    </InnerPageLayout>
  )
}
